import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CommonsConfigEnvironment, CONFIG_ENVIRONMENT } from '@mirage-projects/cw-models';

@Injectable({ providedIn: 'root' })
export class JsonVersionInterceptor implements HttpInterceptor {
    constructor(@Inject(CONFIG_ENVIRONMENT) private configEnvironment: CommonsConfigEnvironment) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const isJsonUrl = req.url.match(/\.json($|\?)/);
        const hasVersionParams = /[?&]v=/.test(req.url);
        if (!isJsonUrl || hasVersionParams) {
            return next.handle(req);
        }

        const newUrl = this.addVersionToUrl(req.url);
        const clonedRequest = req.clone({ url: newUrl });
        return next.handle(clonedRequest);
    }

    private addVersionToUrl(url: string): string {
        const version = this.configEnvironment.productVersion;
        const paramSeparator = url.includes('?') ? '&' : '?';
        const newUrl = `${url}${paramSeparator}v=${version}`;
        return newUrl;
    }
}
